
export enum OrderStatusEnum {
    NEW=1, 
    PARTIALLY_COMPLETED=2, 
    COMPLETED=3,
    
}